/**
 * Maps gateway BetSSO callback error codes to user-facing copy.
 * The SSO app never posts the BetSSO client secret as a password.
 */
export function getSsoErrorMessage(errorCode, message) {
  if (String(errorCode) === '6') {
    return (
      message ||
      'BetConstruct sign-in is temporarily unavailable. Please use email and password or try again later.'
    );
  }
  return message || '';
}
